import React, {Component} from 'react';
import {Redirect} from "react-router-dom";


class PersonMessages extends Component {

    state = {
        redirect : null,
        message_box_open : false,
        first_name:'',
        last_name:'',
        personsMessages : [],        
        currentInd :-1,
        messagesCount:0
    }

    toggleOpenClose = () =>  {
        const open = !this.state.message_box_open;    
        this.setState({message_box_open:open});         
    }

    componentDidMount = () => {
       console.log('PersonMessages componentDidMount', this.props)
        const { first_name, last_name, personsMessages }= this.props.personData;
        this.setState({ personsMessages: personsMessages});
        this.setState({ first_name: first_name});
        this.setState({ last_name: last_name});
        if(personsMessages) {
            this.setState({ messagesCount: personsMessages.length});
        }
    }


    LogOut = () => {
        sessionStorage.clear();
        this.props.onLoggedOutRefresh();
    }

  render() { 



    const firstMessages = this.state.personsMessages.map((msg,index) => {
        return (
            <React.Fragment  key={msg.key} >
                    
                    <div className="hp_messages_box_content_title">
                        {msg.title}
                    </div>                        
                    <div className="hp_messages_box_content_text">
                        {msg.content}                            
                    </div>
                    
            </React.Fragment>
        )
    });


    
    if (this.state.redirect) {
        return <Redirect to={this.state.redirect} />
    } 

    let ind = this.state.currentInd;
    let  msg = {title:'', content: ''};
    if(this.state.personsMessages) {
        if (this.state.personsMessages.length >= 0) {
            ind = 0;

        }
        msg = this.state.personsMessages[ind];
    }


    return (
      <React.Fragment>        
            <div className="hp_uppermenu_item_left marginRight50 unselectable" 
                    onClick={this.toggleOpenClose}>
                <div className="nonActive showBigScreenOnly">
                    שלום
                </div>
                <div className="active marginRight10 showBigScreenOnly">
                    {this.state.first_name + ' ' + this.state.last_name}
                </div>

                <div className="marginRight10">
                    <img src={"/images/site/down.png"} alt=""/>
                </div>

                <div className="hp_uppermenu_messages_box_rightSpace relativePos" >
                    <img src={"/images/site/messages.png"} alt=""/>

                    <div className="hp_messages_tag_circle">
                        <div className="hp_messages_tag_num"> {this.state.messagesCount }</div>                    
                    </div>
                </div>
            </div>

            {(this.state.message_box_open)?
                <div className="hp_messages_box">
                    <div className="hp_messages_box_title"> 
                        <div className="back_arrow pointer" onClick={this.toggleOpenClose}></div>
                        <div className="hp_messages_box_title_inner">ההודעות שלך</div>                    
                    </div>
                    <div className="hp_messages_box_content_wrapper">
                        {firstMessages}
                    </div>
                   
                    <div className="hp_messages_box_bottom">
                        <div className="hp_messages_box_title_inner pointer"
                            onClick={this.LogOut} >התנתק</div>
                    </div>
                </div>
            : null}        
        </React.Fragment>
    )
  }
}

export default PersonMessages;
